import React, { useState, useRef, useEffect } from "react";
import styles from "./Games.module.scss";
import TinySlider from "tiny-slider-react";
import SliderControls from "./SliderButton";
import sliderStyles from "./TinySlider.module.scss";
import { Context } from "../Store";
import { trackEvent } from "../utils/helpers";

const gameConfig = {
  TheEdge: {
    image: "game-the-edge.webp",
    message: "Closest to the Edge",
    borderColor: "var(--color-tan-100)",
    fontColor: "var(--color-cream-100)",
    scoreUnit: "PTS",
    mobileBackground: "es-the-edge-games-bg-mobile.webp",
    smallDesktopBackground: "es-the-edge-games-bg-desktop-small.webp",
    largeDesktopBackground: "es-the-edge-games-bg-desktop-large.webp",
  },
  Territory: {
    image: "game-territory.webp",
    message: "Most Territory",
    borderColor: "var(--color-cream-60)",
    scoreUnit: "%",
    mobileBackground: "es-territory-games-bg-mobile.webp",
    smallDesktopBackground: "es-territory-games-bg-desktop-small.webp",
    largeDesktopBackground: "es-territory-games-bg-desktop-large.webp",
  },
  Eclipse: {
    image: "game-eclipse.webp",
    message: "Nearest Eclipse",
    borderColor: "var(--color-orange-60)",
    scoreUnit: "mm",
    mobileBackground: "es-eclipse-games-bg-mobile.webp",
    smallDesktopBackground: "es-eclipse-games-bg-desktop-small.webp",
    largeDesktopBackground: "es-eclipse-games-bg-desktop-large.webp",
  },
  ShortCircuit: {
    image: "game-short-circuit.webp",
    message: "Shortest Circuit",
    borderColor: "var(--color-tan-100)",
    scoreUnit: "mm",
    mobileBackground: "es-short-circuit-games-bg-mobile.webp",
    smallDesktopBackground: "es-short-circuit-games-bg-desktop-small.webp",
    largeDesktopBackground: "es-short-circuit-games-bg-desktop-large.webp",
  },
  Amplifier: {
    image: "game-amplifier.webp",
    message: "Highest Score",
    borderColor: "var(--color-orange-60)",
    scoreUnit: "PTS",
    mobileBackground: "es-amplifier-games-bg-mobile.webp",
    smallDesktopBackground: "es-amplifier-games-bg-desktop-small.webp",
    largeDesktopBackground: "es-amplifier-games-bg-desktop-large.webp",
  },
  Studio: {
    image: "game-studio.webp",
    message: "Top Studio",
    borderColor: "var(--color-cream-100)",
    mobileBackground: "es-studio-21-games-bg-mobile.webp",
    smallDesktopBackground: "es-studio-21-games-bg-desktop-small.webp",
    largeDesktopBackground: "es-studio-21-games-bg-desktop-large.webp",
  },
};

const Games = (props) => {
  const state = React.useContext(Context);

  const sortedGames = [...state.games].sort((a, b) => (a.game === "TheEdge" ? -1 : b.game === "TheEdge" ? 1 : 0));

  const [hoveredGame, setHoveredGame] = useState(null);
  const [displayedDesktopGame, setDisplayedDesktopGame] = useState(null);

  let games = sortedGames.map((game, index) => {
    let player = state.players.filter((player) => {
      return player.id == game.players;
    })[0];
    let playerPhoto = player.photo
      ? "data:image/jpeg;base64, " + player.photo
      : player.gender == "male"
        ? "./img/boy.png"
        : "./img/girl.png";

    const {
      image: bgImage = "game-amplifier.png",
      message = "",
      borderColor = "white",
      fontColor,
      scoreUnit,
    } = gameConfig[game.game] ?? {};

    return (
      <div
        key={game.id}
        id={"game_" + game.id}
        className={[styles.gamesItem].join(" ")}
        onMouseEnter={() => {
          setDisplayedDesktopGame(game.game);
          setHoveredGame(game.game);
        }}
        onMouseLeave={() => setHoveredGame(null)}
      >
        <div
          className={[
            styles.gamesTile,
            styles["game_no-" + state.games.length],
            styles["game-" + game.game.toLowerCase()],
          ].join(" ")}
        >
          <img className={styles.gameBg} src={`./img/${bgImage}`} alt="" />
          <div
            className={styles.playerContainer}
            style={(game.edgeScore ?? game.highscore) !== undefined ? { top: "57%" } : undefined}
          >
            <div className={styles.gameMessage} style={fontColor ? { color: fontColor } : undefined}>
              {message}
            </div>
            <div className={styles.playerBorder} style={{ outlineColor: borderColor }}>
              <img className={styles.gamePlayer} src={playerPhoto} alt="" />
            </div>
            <div className={styles.playerName} style={fontColor ? { color: fontColor } : undefined}>
              {player.name.toLowerCase()}
            </div>
            {(game.edgeScore ?? game.highscore) !== undefined && (
              <div className={styles.highscore} style={fontColor ? { color: fontColor } : undefined}>
                {game.edgeScore ?? game.highscore}
                {scoreUnit &&
                  (scoreUnit === "%" ? (
                    <span className={styles.scoreUnitFull} style={{ paddingLeft: "4px" }}>
                      %
                    </span>
                  ) : (
                    <span>{scoreUnit}</span>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  });

  const sliderRef = useRef();
  const hasTrackedScrollRef = useRef(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const slider = sliderRef.current?.slider;
    if (!slider) return;
    const updateIndex = (info) => setCurrentIndex((info.displayIndex ?? info.index + 1) - 1);
    updateIndex(slider.getInfo());
    slider.events.on("indexChanged", updateIndex);
    return () => slider.events.off("indexChanged", updateIndex);
  }, [sliderRef]);

  const settings = {
    lazyload: true,
    touch: true,
    nav: false,
    controlsContainer: "." + styles.sliderContainer + " .sliderControls",
    mouseDrag: true,
    loop: false,
    autoHeight: true,
    fixedWidth: 331,
    gutter: 16,
    edgePadding: 22,
    center: true,
    responsive: {
      1024: {
        fixedWidth: 370,
        gutter: 16,
        edgePadding: 30,
        center: false,
      },
    },
  };

  // useEffect(() => {
  //   animOnSwipe(sliderRef.current.slider);
  // });

  return (
    <div className={`section light ${styles.gamesSection}`}>
      {gameConfig[sortedGames[currentIndex]?.game]?.mobileBackground && (
        <img
          className={styles.sectionIllustration}
          src={`./img/${gameConfig[sortedGames[currentIndex].game].mobileBackground}`}
          alt=""
        />
      )}
      {gameConfig[displayedDesktopGame]?.smallDesktopBackground && (
        <img
          className={styles.sectionIllustrationDesktop}
          src={`./img/${gameConfig[displayedDesktopGame].smallDesktopBackground}`}
          style={{ opacity: hoveredGame ? 1 : 0 }}
          alt=""
        />
      )}
      {gameConfig[displayedDesktopGame]?.largeDesktopBackground && (
        <img
          className={styles.sectionIllustrationDesktopLarge}
          src={`./img/${gameConfig[displayedDesktopGame].largeDesktopBackground}`}
          style={{ opacity: hoveredGame ? 1 : 0 }}
          alt=""
        />
      )}
      <h2>Mighty Pucks</h2>
      <h3>achievements</h3>
      {games.length === 1 ? (
        <div className={styles.sliderContainer} style={{ maxWidth: 370 + 60 }}>
          <div className={styles.singleGameContainer}>{games}</div>
        </div>
      ) : (
        <>
          <div className={styles.sliderContainer} style={{ maxWidth: games.length * (370 + 16) - 16 + 60 }}>
            <SliderControls slider={sliderRef}></SliderControls>

            <TinySlider
              settings={settings}
              ref={sliderRef}
              onIndexChanged={() => {
                if (!hasTrackedScrollRef.current) {
                  hasTrackedScrollRef.current = true;
                  trackEvent("Gallery Scroll", "game_achievements_scroll");
                }
              }}
            >
              {games}
            </TinySlider>
          </div>
          <div className={styles.counterRow}>
            <p className={styles.slideCounter}>
              <span>{currentIndex + 1}</span>/{games.length}
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default Games;
